import type { IFileImage } from '@/types/file.types';
import { reactive, ref } from 'vue';

export const pageFile = ref(1);
export const fileId = ref(null);
export const fileSearchQuery = ref(null);
export const previewUrl = ref<string | null>(null);

export const form_FilfeBodyAdd = reactive<IFileImage>({
  designation: '',
});

export const file = ref<File | null>(null);
export const isComingFromFileDeleted = ref(false);
